import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorCircleIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import validator from 'validator'

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: 'absolute',
    width: '550px',
    height: '600px',
    left: 'calc((100% - 50px - 550px) / 2)',
    top: 'calc((100% + 30px - 600px) / 2)',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing(0.5),
  },
});

/*const sublocations = [
  { title: 'Schemmerhofen', sublocation: 'Schemmerhofen' },
  { title: 'Schemmerberg', sublocation: 'Schemmerberg' },
  { title: 'Ingerkingen', sublocation: 'Ingerkingen' },
  { title: 'Aßmannshardt', sublocation: 'Aßmannshardt' },
  { title: 'Alberweiler', sublocation: 'Alberweiler' },
  { title: 'Altheim', sublocation: 'Altheim' }
];*/

const sublocations = [
  'Schemmerhofen',
  'Schemmerberg',
  'Ingerkingen',
  'Aßmannshardt',
  'Alberweiler',
  'Altheim'
];

class Form extends React.Component {
  state = {
    loading: false,
    first_name: "",
    last_name: "",
    street: "",
    house_number: "",
    sublocation: "",
    location_description: "",
    email: "",
    snackbar_open: false,
    snackbar_error_open: false,
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  onReset = () => {
    //Formular zurücksetzen
    this.setState({ first_name: "", last_name: "", street: "", house_number: "", sublocation: "", location_description: "", email: "", loading: false });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false, snackbar_error_open: false });
  }

  onSend = () => {
    if(this.state.first_name !== "" && this.state.last_name !== "" && this.state.street !== "" && this.state.house_number !== "" && this.state.sublocation !== "" && this.state.email !== "" && validator.isEmail(this.state.email)) {
      //Anmeldung absenden
      this.setState({ error_first_name: false, error_last_name: false, error_street: false, error_house_number: false, error_sublocation: false, error_email: false, loading: true });

      let currentComponent = this;
      request.post('https://formulare-schemmerhofen.de/blumen/backend.php')
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send({command: "newregistration", first_name: this.state.first_name, last_name: this.state.last_name, street: this.state.street, house_number: this.state.house_number, sublocation: this.state.sublocation, location_description: this.state.location_description, email: this.state.email})
        .end(function(_, res) {
          var result = res.text.trim();
          if(result === "1") {
            currentComponent.setState({ snackbar_open: true });
            currentComponent.onReset();
          } else {
            currentComponent.setState({ loading: false, snackbar_error_open: true });
          }
        });
    } else {
      this.setState({ error_first_name: this.state.first_name === "", error_last_name: this.state.last_name === "", error_street: this.state.street === "", error_house_number: this.state.house_number === "", error_sublocation: this.state.sublocation === "", error_email: this.state.email === "" || !validator.isEmail(this.state.email) });
    }
  }

  render() {
    const { classes, fullScreen } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open aria-labelledby="responsive-dialog-title" BackdropProps={{style: {backgroundColor: "transparent"}}}>
        <DialogTitle id="responsive-dialog-title">Anmeldung Blumenschmuckwettbewerb</DialogTitle>
        <DialogContent>
          <DialogContentText>Bitte füllen Sie das Formular unten aus um sich für den Blumenschmuckwettbewerb anzumelden.</DialogContentText>
          {/* Vorname */}
          <TextField label="Vorname" value={this.state.first_name} onChange={this.handleChange("first_name")} margin="dense" style={{width: "49%", marginRight: "2%"}} error={this.state.error_first_name} inputProps={{ maxLength: 30 }} required />
          {/* Nachname */}
          <TextField label="Nachname" value={this.state.last_name} onChange={this.handleChange("last_name")} margin="dense" style={{width: "49%"}} error={this.state.error_last_name} inputProps={{ maxLength: 30 }} required />
          {/* Straße */}
          <TextField label="Straße" value={this.state.street} onChange={this.handleChange("street")} margin="dense" style={{width: "69%", marginRight: "2%"}} error={this.state.error_steet} inputProps={{ maxLength: 50 }} required />
          {/* Hausnummer */}
          <TextField label="Hausnummer" value={this.state.house_number} onChange={this.handleChange("house_number")} margin="dense" style={{width: "29%"}} error={this.state.error_house_number} inputProps={{ maxLength: 10 }} required />
          {/* Teilort */}
          <Autocomplete
            options={sublocations}
            margin="dense"
            value={this.state.sublocation}
            onChange={(_, newValue) => {
              this.setState({ sublocation: newValue });
            }}
            style={{width: "34%", marginRight: "2%"}}
            renderInput={(params) => <TextField {...params} label="Teilort" error={this.state.error_sublocation} required />}
          />
          {/* E-Mail */}
          <TextField label="E-Mail Adresse" value={this.state.email} onChange={this.handleChange("email")} margin="dense" style={{width: "49%", marginTop: 10}} error={this.state.error_email} inputProps={{ maxLength: 100 }} required />
          {/* Lokationsbeschreibung */}
          <TextField label="Lage auf dem Grundstück" value={this.state.location_description} onChange={this.handleChange("location_description")} margin="dense" style={{width: "100%"}} inputProps={{ maxLength: 500 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onReset} variant="contained" disabled={this.state.loading}>Formular zurücksetzen</Button>
          <Button onClick={this.onSend} variant="contained" disabled={this.state.loading} color="primary">
            Anmeldung speichern
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        <Snackbar className={classes.success} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <CheckCircleIcon className={classes.icon} />
                Ihre Anmeldung wurde erfolgreich gespeichert.
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{fontSize: 20}} />
              </IconButton>,
            ]}
            style={{backgroundColor: green[600]}} />
        </Snackbar>
        <Snackbar className={classes.error} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_error_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorCircleIcon className={classes.icon} />
                Ihre Anmeldung ist bereits vorhanden oder es gab einen Fehler
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{fontSize: 20}} />
              </IconButton>,
            ]}
            style={{backgroundColor: red[600]}} />
        </Snackbar>
      </Dialog>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(Form));
